module.exports = __webpack_public_path__ + "static/tags_1-82c37342d6c57b8b3aa166a3aacb3a4e.webm";